import { render } from "./DataRequirementRequestView.vue?vue&type=template&id=320512b5&scoped=true"
import script from "./DataRequirementRequestView.vue?vue&type=script&lang=js"
export * from "./DataRequirementRequestView.vue?vue&type=script&lang=js"

import "./DataRequirementRequestView.vue?vue&type=style&index=0&id=320512b5&lang=css&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-320512b5"]])

export default __exports__